
<table mat-table [dataSource]="patientDataSource">

	<ng-container matColumnDef="key">
		<th mat-header-cell *matHeaderCellDef>Key</th>
		<td mat-cell *matCellDef="let row" class="table-key">
			<div class="mrn sub">{{ row.key}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="value">
		<th mat-header-cell *matHeaderCellDef>Value</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.value}}</div>
		</td>
	</ng-container>

	<tr mat-row *matRowDef="let row; columns: displayedColumns;"  (click)="gotoRow(row)">

</table>
